export type RegisterErrorMessages = {
  errorRequiredUserName: string;
  errorRequiredEmail: string;
  errorInvalidEmail: string;
  errorRequiredPhone: string;
  errorRequiredCompanyName: string;
  invalidCNPJ: string;
  passwordFormatError: string;
  errorRequiredPassword: string;
  errorPasswordMismatch: string;
  errorRequiredConfirmPassword: string;
  getNewUserDefaultMessage: string;
  errorPasswordLength: string;
  errorPasswordLowercase: string;
  errorPasswordUppercase: string;
  errorPasswordNumeric: string;
  errorPasswordSpecialChar: string;
  errorEmailExists: string;

  invalidCnpj: string;
  unauthorized: string;
  accessDenied: string;
  cnpjNotFound: string;
  tooManyRequests: string;
  internalServerError: string;
  connectionError: string;
};

export const REGISTER_ERROR_MESSAGES: RegisterErrorMessages = {
  errorRequiredUserName: "Nome é obrigatório.",
  errorRequiredEmail: "Por favor, insira seu e-mail",
  errorInvalidEmail: "Email inválido",
  errorRequiredPhone: "Telefone com DDD é obrigatório.",
  errorRequiredCompanyName: "Empresa é obrigatória.",
  invalidCNPJ: "Digite um CNPJ válido",
  passwordFormatError: "Senha inválida",
  errorRequiredPassword: "Por favor, insira uma senha",
  errorPasswordMismatch: "As senhas não coincidem",
  errorRequiredConfirmPassword: "Por favor, confirme sua senha",
  getNewUserDefaultMessage: "Erro ao criar usuário",
  errorPasswordLength: "A senha deve ter no mínimo 8 caracteres.",
  errorPasswordLowercase: "A senha deve conter pelo menos 1 caractere minúsculo ('a'-'z').",
  errorPasswordUppercase: "A senha deve conter pelo menos 1 caractere maiúsculo ('A'-'Z').",
  errorPasswordNumeric: "A senha deve conter pelo menos 1 caractere numérico.",
  errorPasswordSpecialChar: "A senha deve conter pelo menos 1 caractere especial.",
  errorEmailExists: "Este e-mail já está sendo usado.",

  invalidCnpj: "CNPJ inválido. Por favor, verifique e tente novamente.",
  unauthorized: "Não autorizado. Verifique suas credenciais.",
  accessDenied: "Acesso negado. Você não tem permissão para acessar essa API.",
  cnpjNotFound: "CNPJ não encontrado. Verifique e tente novamente.",
  tooManyRequests: "Muitas requisições. Tente novamente em 1 minuto.",
  internalServerError: "Erro interno do servidor. Tente novamente mais tarde.",
  connectionError: "Erro de conexão. Verifique sua conexão com a internet.",
};
